import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { ReportGridRequest } from '@/api/services/common.dto'

class RegistryCasePrintService {
    private static async _getAPR(laboratoryId: number, casId: number, casesAssociated: boolean, encoded: boolean): Promise<Blob> {
        const config: AxiosRequestConfig = {
            params: { casesAssociated, encoded },
            headers: { type: 'application/pdf' },
            responseType: encoded ? 'text' : 'arraybuffer'
        }
        const response = await axios.get<Blob>(`/common/laboratories/${laboratoryId}/cases/${casId}/reports`, config)
        return response.data
    }
    async getCaseAPReportPdfForPrinting(laboratoryId: number, casId: number, casesAssociated: boolean): Promise<Blob> {
        return RegistryCasePrintService._getAPR(laboratoryId, casId, casesAssociated, true)
    }
    async downloadCaseAPReportPdf(laboratoryId: number, casId: number, casesAssociated: boolean): Promise<Blob> {
        return RegistryCasePrintService._getAPR(laboratoryId, casId, casesAssociated, false)
    }

    async getCaseLabels(laboratoryId: number, casId: number, numOfCopiesForCaseLabels: number): Promise<Blob> {
        const config: AxiosRequestConfig = {
            params: { numOfCopiesForCaseLabels },
            headers: { type: 'application/pdf' },
            responseType: 'arraybuffer'
        }
        const response = await axios.get<Blob>(`registry/laboratories/${laboratoryId}/cases/${casId}/labels`, config)
        return response.data
    }

    async exportTo(laboratoryId: number, params: ExportCommonParams, request: ReportGridRequest): Promise<AxiosResponse<Blob>> {
        return axios.put<Blob>(
            `registry/laboratories/${laboratoryId}/cases/reportCasesGrid`,
            request,
            { params, responseType: 'arraybuffer' })
    }
}
export const registryCasePrintService = new RegistryCasePrintService()
